export interface IKeyCollection<T> {
  add(key: string, value: T): void;
  containsKey(key: string): boolean;
  size(): number;
  getItem(key: string): T;
  removeItem(key: string): T;
  getKeys(): string[];
  values(): T[];
}

export class KeyValuePair<T> implements IKeyCollection<T> {
  private items: { [index: string]: T } = {};
  private count = 0;
  public add(key: string, value: T) {
    if (!this.items.hasOwnProperty(key)) {
      this.count++;
    }
    this.items[key] = value;
  }

  public containsKey(key: string): boolean {
    return this.items.hasOwnProperty(key);
  }

  public size(): number {
    return this.count;
  }

  public getItem(key: string): T {
    return this.items[key];
  }

  public removeItem(key: string): T {
    const value = this.items[key];
    delete this.items[key];
    this.count--;
    return value;
  }

  public getItems(): { [index: string]: T } {
    return this.items;
  }

  public getKeys(): string[] {
    const keySet: string[] = [];
    for (const property in this.items) {
      if (this.items.hasOwnProperty(property)) {
        keySet.push(property);
      }
    }
    return keySet;
  }

  public setItems(items: any) {
    this.items = items;
    this.count = Object.keys(items).length;
  }

  public values(): T[] {
    const values: T[] = [];
    for (const property in this.items) {
      if (this.items.hasOwnProperty(property)) {
        values.push(this.items[property]);
      }
    }
    return values;
  }
}
